import api from './axiosApi'

export type ReportType = 'CAT' | 'IFP'

export interface MyDashboardAccess {
  is_admin: boolean
  cat_access: boolean
  ifp_report_ids: string[]
}

export interface ReportPermissionUser {
  id: string
  email: string
  display_name: string | null
  role: string
  permission_id: string
}

export interface ReportAssignment {
  report_id: string
  report_type: ReportType
  users: ReportPermissionUser[]
}

interface ReportAssignmentsResponse {
  reports: ReportAssignment[]
}

export interface AssignedReport {
  permission_id: string
  report_id: string
  report_type: ReportType
}

export interface UserAssignment {
  user_id: string
  email: string
  display_name: string | null
  role: string
  reports: AssignedReport[]
}

interface UserAssignmentsResponse {
  users: UserAssignment[]
}

export interface ReportPermissionCreate {
  user_id: string
  report_id: string
  report_type: ReportType
}

export interface ReportPermissionRead {
  id: string
  user_id: string
  report_id: string
  report_type: ReportType
  created_at: string
  updated_at: string
}

export async function fetchMyDashboardAccess(): Promise<MyDashboardAccess> {
  const { data } = await api.get<MyDashboardAccess>(
    '/dashboards/permissions/me'
  )
  return data
}

export async function fetchReportAssignments(): Promise<ReportAssignment[]> {
  const { data } = await api.get<ReportAssignmentsResponse>(
    '/dashboards/permissions'
  )
  return data.reports
}

export async function fetchUserAssignments(): Promise<UserAssignment[]> {
  const { data } = await api.get<UserAssignmentsResponse>(
    '/dashboards/permissions/by-user'
  )
  return data.users
}

export async function createReportPermission(
  body: ReportPermissionCreate
): Promise<ReportPermissionRead> {
  const { data } = await api.post<ReportPermissionRead>(
    '/dashboards/permissions',
    body
  )
  return data
}

export async function deleteReportPermission(
  permissionId: string
): Promise<void> {
  await api.delete(`/dashboards/permissions/${permissionId}`)
}
